import { render, staticRenderFns } from "./TemplateCreatePopup.vue?vue&type=template&id=24bf2e91&lang=pug&"
import script from "./TemplateCreatePopup.vue?vue&type=script&lang=js&"
export * from "./TemplateCreatePopup.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCreatePopup.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bf2e91')) {
      api.createRecord('24bf2e91', component.options)
    } else {
      api.reload('24bf2e91', component.options)
    }
    module.hot.accept("./TemplateCreatePopup.vue?vue&type=template&id=24bf2e91&lang=pug&", function () {
      api.rerender('24bf2e91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/TemplateCreatePopup.vue"
export default component.exports